<!--
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: liyong
 * @Date: 2022-08-03 16:54:50
 * @LastEditors: liushuaibo liushuaibo@yangxuan.net
 * @LastEditTime: 2023-07-05 11:55:52
 * @FilePath: /partner.chaoyongtuan.com/src/views/shopManage/shopLibrary/list/tableCells/sampleCell.vue
 *
 * Copyright (c) 2022 by 央选/李勇, All Rights Reserved.
-->
<template>
	<div>
		<div v-if="!recommend_type.length">-</div>
		<template v-else>
			<div v-for="(item, index) in recommend_type" :key="index">{{ item }}</div>
		</template>
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin';
export default {
	mixins: [mixin],

	computed: {
		recommend_type({ row }) {
			return row.recommend_type || [];
		},
	},
};
</script>
<style lang="less" scoped>
</style>
